import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { landingContent } from "../../data/landingContent";

export function FAQSection() {
  const { faq } = landingContent;
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="st-section" style={{ background: "#FFF" }}>
      <div className="st-container" style={{ textAlign: "center", marginBottom: "36px" }}>
        <h2 className="st-heading-2">
          {faq.title}
        </h2>
        <p className="st-body-large" style={{ maxWidth: "600px", margin: "0 auto" }}>
          {faq.subtitle}
        </p>
      </div>
      
      <div className="st-container">
        <div className="st-faq-list">
          {faq.items.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div 
                key={index} 
                className="st-faq-item"
                style={{
                  background: "var(--gray-light)",
                  border: "1.5px solid rgba(15, 23, 42, 0.06)",
                  borderRadius: "12px",
                  marginBottom: "8px",
                  overflow: "hidden"
                }}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 20px",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer",
                    fontSize: "0.9375rem",
                    fontWeight: 800,
                    color: "var(--slate-900)"
                  }}
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>
                  <ChevronDown 
                    size={16} 
                    style={{
                      color: "var(--pink-primary)",
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                      flexShrink: 0
                    }} 
                  />
                </button>
                <div 
                  style={{
                    maxHeight: isOpen ? "150px" : "0",
                    opacity: isOpen ? 1 : 0,
                    overflow: "hidden",
                    transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                >
                  <p style={{
                    margin: 0,
                    padding: "0 20px 16px 20px",
                    fontSize: "0.875rem",
                    color: "var(--slate-600)",
                    lineHeight: 1.5,
                    fontWeight: 500
                  }}>
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
